import React from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
//import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
// !! استيراد useQueryClient !!
import { useMutation, useQueryClient } from '@tanstack/react-query';
// !! تغيير الاستيراد !!
import * as serviceRequestService from '../../services/serviceRequestService';
import { useAuth } from '../../hooks/useAuth'
import pageStyles from '../Page.module.css';
import formStyles from '../../components/forms/Form.module.css';

// تعريف أنواع حقول النموذج
interface FormInputs {
  motivationLetter: string;
  // لم نعد نرفع ملفات مباشرة، بل يمكننا إرسال روابطها أو بياناتها كـ JSON
}

const TrainingApplication: React.FC = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm<FormInputs>();
  
    const { user } = useAuth();
  const mutation = useMutation({
    // !! تغيير الدالة !!
    mutationFn: serviceRequestService.createServiceRequest,
    onSuccess: () => {
      toast.success('تم إرسال طلبك بنجاح! سيتم مراجعته قريباً.');
      queryClient.invalidateQueries({ queryKey: ['myServiceRequests'] });
      navigate('/subscriber/dashboard');
    },
    onError: (err: any) => {
      toast.error(err.response?.data?.message || 'فشل إرسال الطلب.');
    },
  });

  const onSubmit: SubmitHandler<FormInputs> = (data) => {
 
    if (!user) {
      toast.error("يجب أن تكون مسجلاً دخولك لتقديم طلب.");
      return;
    }
    // !! بناء كائن طلب الخدمة !!
    const requestData: serviceRequestService.CreateServiceRequestData = {
      //user_id: 2,
      service_id: 1, // !! استخدم الـ ID الفعلي لخدمة "الالتحاق بالتدريب" !!
      fee: 0.00, // الرسوم الفعلية للخدمة
      documents: {
        motivationLetter: data.motivationLetter,
        // يمكنك إضافة حقول أخرى هنا إذا لزم الأمر
      },
    };
    mutation.mutate(requestData);
  };

  return (
    <div className={pageStyles.pageContainer}>
      <h1 className={pageStyles.pageTitle}>طلب الالتحاق بالتدريب</h1>
      <form onSubmit={handleSubmit(onSubmit)} className={formStyles.form}>
        <div className={formStyles.formField}>
          <label htmlFor="motivationLetter" className={formStyles.label}>
            رسالة الدافع
          </label>
          <textarea
            id="motivationLetter"
            rows={6}
            {...register('motivationLetter', { required: 'رسالة الدافع مطلوبة' })}
            className={formStyles.textarea}
            placeholder="اشرح لماذا ترغب في الانضمام لبرنامج التدريب..."
          />
          {errors.motivationLetter && <p className={formStyles.error}>{errors.motivationLetter.message}</p>}
        </div>

        {/* يمكنك إزالة حقل رفع الملفات إذا لم تكن بحاجة إليه الآن */}

        <button type="submit" disabled={isSubmitting} className={formStyles.submitButton}>
          {isSubmitting ? 'جاري الإرسال...' : 'إرسال الطلب'}
        </button>
      </form>
    </div>
  );
};

export default TrainingApplication;
